import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';

import { API_URL } from '@/dtos';

const GET_PREFUND_RETURN_STATUS_QUERY_KEY = 'GET_PREFUND_RETURN_STATUS_QUERY_KEY';

export const useGetPrefundReturnStatusQuery = (invoiceId?: string, enabled?: boolean) => {
  const { isLoading, isSuccess, data, refetch } = useQuery(
    [GET_PREFUND_RETURN_STATUS_QUERY_KEY, invoiceId, enabled],
    invoiceId ? () => api.get(API_URL.PREFUND_RETURNS_INVOICES_BY_INVOICE_ID(invoiceId)) : () => null,
    {
      retry: 0,
      enabled,
    }
  );

  const prefundReturnStatus = useMemo(() => {
    if (!data) return null;
    return data.data?.status;
  }, [data]);

  return {
    data: data?.data,
    prefundReturnStatus,
    isLoading,
    isSuccess,
    refetch,
  };
};
